﻿
/* @preserve
// [Payment Validation]
// ------------------------------------------
// @author Erik Northfell (The Belford Group)
// @version 2.0.0
*/

"use strict";

// Custom Expiration Date Validation
// Example: cboMonth: {CreditCardExpired: "#cboYear"}
// ------------------------------------------
$.validator.addMethod('creditCardExpired', (value, element, param) => {
    let expireMonth = value;
    let expireYear = $(param).val();
    if (expireMonth && expireMonth.toString().length > 0 && expireYear && expireYear.toString().length > 0) {
        expireMonth = expireMonth.toString().trim();
        expireYear = expireYear.toString().trim();
        if (expireMonth.length === 1) {expireMonth = `0${expireMonth}`;}
        if (expireYear.length === 1) {expireYear = `0${expireYear}`;}
        const expireCombined = luxon.DateTime.fromFormat(`${expireMonth}/01/${expireYear}`, "MM/dd/yy").endOf('month');
        const startDate = luxon.DateTime.now().startOf('day');
        const isAfter = expireCombined > startDate;
        //console.log("ExpireCombined(" + expireCombined + ") is after Now(" + startDate + ")? " + isAfter);
        return isAfter;
    } else {
        return false;
    }
}, (param, element) => {
	const expireMonth = $(element).val();
    const expireYear = $(param).val();
	if (expireMonth && expireMonth.length > 0 && expireYear && expireYear.length > 0) {
		// Month and year exist; return that the date combo is invalid.
		return "Expiration date cannot be in the past.";
	} else {
		if (expireMonth.length > 0) {
			// Month exists
			return "Please enter a year.";
		} else {
			// Year exists
			return "Please enter a month.";
		}
	}
});

// Validation for Credit Cards
// ------------------------------------------
// [param] {@OBJECT}
// -- [cardFormGroup] {@DOMELEMENT} - Required. The form group.
// -- [cardImage] {@DOMELEMENT} - Required. The card image.
// -- [cardTypeInput] {@DOMELEMENT} - Required. The card type input.
// ------------------------------------------
$.validator.addMethod('creditCardImage', function (value, element, param) {
    if (this.optional(element)) { return "dependency-mismatch"; }
    let validCardResult = $(element).validateCreditCard({ accept: ['visa', 'mastercard', 'amex', 'discover'] });
    if (validCardResult.length_valid && validCardResult.luhn_valid) {
        param.cardFormGroup.classList.add("valid-cc");
        param.cardImage.setAttribute("src", "/images/credit-cards/" + validCardResult.card_type.name.toLowerCase() + "-straight-64px.png");
        let ccType = "";
        let ccAlt = "";
        switch (validCardResult.card_type.name.toLowerCase()) {
            case "visa":
                ccType = "Visa";
				ccAlt = "Visa credit card image";
                break;
            case "amex":
                ccType = "American Express";
				ccAlt = "American Express credit card image";
                break;
            case "discover":
                ccType = "Discover";
				ccAlt = "Discover credit card image";
                break;
            case "mastercard":
                ccType = "Mastercard";
				ccAlt = "Mastercard credit card image";
                break;
        }
        param.cardTypeInput.value = ccType;
        param.cardTypeInput.setAttribute("alt",ccAlt);
        //console.info("Validate CC: [", value, "], [VALID " + ccType + "]");
        return true;
    } else {
        param.cardFormGroup.classList.remove("valid-cc");
        param.cardImage.setAttribute("src", "/images/credit-cards/empty-64px.png");
        param.cardTypeInput.value = "";
        param.cardTypeInput.setAttribute("alt","Empty credit card image");
        //console.warn("Validate CC: [", value, "], [INVALID]");
        return false;
    }
}, "Card number is not valid.");